import { Link } from "react-router-dom"
import styles from "./Tabs.module.scss"
import clsx from "clsx"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { TranslateComponent } from "src/common/translations"

// This function is used to handle the state passed to the Link component.
// It checks if the state is a function and calls it, or returns the state directly.
const linkState = function (state = {} as any) {
  const isFunction = typeof state == "function"

  return isFunction ? state() : state || null
}

const Tabs = ({ navData = [], getUpdatedNav = (data: any) => data }) => {
  const location = useLocation()
  const handlechange = (index: number, event?: React.MouseEvent) => {
    // Prevent navigation if the tab is already active and it's not a redirection tab
    if (navs?.[index]?.active && !navs?.[index]?.isRedirection) {
      event?.preventDefault()
      return
    }

    const handler = navData?.[index]?.handler
    if (handler) {
      handler()
    }
    let updatedNav = navData
    if (!navData?.[index]?.isRedirection) {
      updatedNav = navData.map((item, i) => {
        if (!item?.isRedirection) {
          item.active = i === index
        }
        return item
      })
      setNavs(updatedNav)
    }

    getUpdatedNav(updatedNav)
  }
  const [navs, setNavs] = useState([])
  useEffect(() => {
    const updatedNav = navData.map((item) => {
      if (item?.link) {
        item.active = location.pathname?.split("/")?.includes(item?.pathname)
      }
      return item
    })
    setNavs(updatedNav)
  }, [navData, location.pathname])

  return (
    <ul className={`nav ${styles.navPills}`}>
      {navs?.map((data: any, navIndex) => {
        return (
          <li
            key={navIndex}
            className={clsx({
              [styles.active]: data?.active,
              [styles.disabled]: data?.disabled
            })}
          >
            {(data?.isVisible ?? true) && <>{!data?.isRedirection ? (
              <Link
                to={data?.link ? `${data?.link}` : "#"}
                data-testid={data?.testId}
                onClick={(event) => handlechange(navIndex, event)}
                state={linkState(data?.state) || null}
              >
                <Content data={data} />
              </Link>
            ) : (
              <span
                className={styles.navRedirectionButton}
                onClick={(event) => handlechange(navIndex, event)}
              >
                <Content data={data} />
              </span>
            )}</>}
          </li>
        )
      })}
    </ul>
  )
}

export default Tabs

const Content = (props) => {
  const { data } = props
  return (
    <span>
      <TranslateComponent>{data?.name}</TranslateComponent>
      {data?.showCount && <span>{" (" + data?.count + ") "}</span>}
      {data?.icon && <span className={`btn-icon-right ${data?.icon}`}></span>}
      {data?.subData && <sup>{data?.subData}</sup>}
    </span>
  )
}
